<template>
  <div :class="['filter-area', filterAreaClass]">
    <div class="filter-area-list">
      <Listbox
        v-model="selectedItemIdLocal"
        :tabindex="0"
        :options="entities"
        :filter-fields="filterFields"
        :filter="true"
        :empty-message="noFilterResult"
        :empty-filter-message="noFilterResult"
        scroll-height="100%"
        :pt="filterAreaPt"
        :dt="filterAreaDt"
        @change="onChange"
      >
        <template #header>
          <label class="filterarea-label">
            <strong>{{ labelText }}</strong>
          </label>
        </template>
        <template #option="slotProps">
          <slot
            name="option-content"
            :slot-props="slotProps"
          />
        </template>
        <template #empty>
          <label />
        </template>
      </Listbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue';
import Listbox from 'primevue/listbox';
import resourceHelper from '@/Utils/resourceHelper';
import { FilterAreaType } from '@/VueComponents/SharedComponents/FilterArea/Enums/filterAreaType';
import { filterAreaDt, filterAreaPt } from '@/VueComponents/SharedComponents/FilterArea/PrimeVue/filterAreaConfiguration';

const props = defineProps<{
  modelValue: string | null,
  entities: any,
  itemType: string,
  filterAreaClass: string,
  filterFields: string[]
}>();

const emit = defineEmits<{(e: 'change', selectedItemId: string | null): void}>();
const noFilterResult = resourceHelper.getString('NoFilterResult');
const labelText = props.itemType === FilterAreaType.user ?
  resourceHelper.getString('FilterUsersLabel') : resourceHelper.getString('FilterGroupsLabel');
const selectedItemIdLocal = ref(props.modelValue);
const lastSelectedItem = ref(props.modelValue);

function onChange(event) {
  // make sure that at least one items remains selected as Listbox allows unselection
  if (!event.value) {
    nextTick(() => {
      selectedItemIdLocal.value = lastSelectedItem.value;
    });
    return;
  }
  lastSelectedItem.value = event.value;
  emit('change', event.value);
}

</script>
<style scoped lang="scss">
@import "sass/bootstrap-overrides/variables";


:deep(.pv-filterarea) {
  border: none !important;

  .filterarea-label {
    margin-top: 1rem;
    color: black;
  }

  .pv-filterarea-list-container {
    margin-top: 1.5rem;
    padding-top: 0.25rem;
    border-top: 1px solid #dee2e6;
  }

  .pv-filterarea-option {
    box-sizing: border-box;

    &:hover,&.pv-filterarea-option-hover {
      border-left: $hover-active-nav-y-border;
      padding-left: 6px;
    }

    &.pv-filterarea-option-selected {
      border-left: $active-nav-y-border;
      padding-left: 6px;
    }
  }
}
</style>